import React from 'react'
import styles from "./Footer.module.css" // <-- Use Footer.module.css instead of Homepage.module.css
import { Link } from 'react-router-dom';
import analytics from '../firebase';
import { logEvent } from 'firebase/analytics';

const Footer = () => {
  const handleFooterAnalytics = (type) => {
    // Log the click event for Google Play button
    switch (type) {
      case 'gift':
        logEvent(analytics, "BN Gift Hamper Click", {
          platform: "Web",
        });
        break;
      case 'store':
        logEvent(analytics, "BN Store Click", {
          platform: "Web",
        });
        break;
    
      default:
        return
    }
  };
  return (
    <footer className={styles.footer}>
      <div className={styles.footerLinks}>
        <a className={styles.link} href="/">
          BN App
        </a>{" "}
        <span className={styles.separator}>•</span>
        <Link
          className={styles.link}
          to="/gift-finder"
          onClick={() => handleFooterAnalytics("gift")}
        >
          AI Gift Finder
        </Link>
        {/* <span className={styles.separator}>•</span>
        <a
          className={styles.link}
          href="https://store.getbn.in/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleFooterAnalytics("store")}
        >
          BN Store
        </a> */}
      </div>
      <div className={styles.footerLinks}>
        <a
          className={styles.link}
          href="/contact"
        >
          Contact Us
        </a>
        <span className={styles.separator}>•</span>
        <a className={styles.link} href="/terms">
          Terms & Conditions
        </a>
        <span className={styles.separator}>•</span>
        <a className={styles.link} href="/privacy">
          Privacy Policy
        </a>
      </div>
    </footer>
  );
}

export default Footer
